// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
i[data-v-186debbb] {
  cursor: grab;
}
`, "",{"version":3,"sources":["webpack://./ClientApp/components/kanban/modal/attributedefinitions/VueFormBuilder/DragHandle.vue"],"names":[],"mappings":";AAOA;EACA,YAAA;AACA","sourcesContent":["<template>\r\n  <div>\r\n    <i class=\"fa fa-grip-lines\" />\r\n  </div>\r\n</template>\r\n\r\n<style scoped>\r\ni {\r\n  cursor: grab;\r\n}\r\n</style>\r\n\r\n<script lang=\"ts\">\r\nimport Vue from 'vue';\r\nimport { Component } from 'vue-property-decorator';\r\n\r\n@Component\r\nexport default class DragHandle extends Vue {\r\n}\r\n</script>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
